export const LOOP_FALLBACK_APPROACH = {
  TEACHER_SUBSTITUTION: 2,
  CANCEL_RESCHEDULE: 1,
};

export const PORTAL_ROOT_ID = "portal-root";
